import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { Map, fromJS } from 'immutable';
import { breakpoint, color } from '../styles/helpers/variables';
import { Container } from '../styles/Container';
import connect from '../store/connect';
import { hideOnPrint } from '../styles/helpers/mixins';

const Breadcrumbs = props => {
  if (props.disabled) {
    return false;
  }

  // if sitemap did not load properly, don't render Breadcrumbs (mostly so the pages load properly during development)
  if (!props.sitemap.size) {
    return false;
  }

  const splitPathname = props.location.pathname.length > 1 ? props.location.pathname.split('/') : [''];

  let currentSitemapObject = props.sitemap;
  let pathname = '';
  const breadCrumbs = [];

  for (let i = 0; i < splitPathname.length; i += 1) {
    if (i === 0) {
      breadCrumbs.push({
        title: 'Hem',
        url: '/'
      });
    } else {
      const path = splitPathname[i];
      pathname += `/${path}`;
      // eslint-disable-next-line no-loop-func
      currentSitemapObject = currentSitemapObject.get('children', Map()).find(item => item.get('url') === pathname);

      // if page is not found in Sitemap, ignore everything and skip rendering of Breadcrumbs
      if (!currentSitemapObject) {
        break;
      }

      breadCrumbs.push({
        title: currentSitemapObject.get('title', Map()) || 'hej',
        url: pathname
      });
    }
  }

  if (props.currentItem) {
    breadCrumbs.push(props.currentItem);
  }

  // remove last breadcrumb on mobile displays (for saving space)
  if (props.viewstate.get('pageWidth') < breakpoint.medium) {
    breadCrumbs.splice(-1, 1);
  }
  return (
    <BreadcrumbsContainer>
      {breadCrumbs.map((item, index) => (
        <span key={item.url}>
          <BreadcrumbNavLink to={item.url} active={(item.url === props.location.pathname).toString()}>
            {item.title}
          </BreadcrumbNavLink>
          {index < breadCrumbs.length - 1 ? <span> / </span> : false}
        </span>
      ))}
    </BreadcrumbsContainer>
  );
};

const BreadcrumbNavLink = styled(NavLink)`
  text-decoration: none;
  color: ${color.black};
  transition: opacity 250ms ease-out;
  font-style: italic;

  &:hover {
    opacity: 0.6;
  }

  ${props =>
    props.active === 'true' &&
    css`
      font-weight: 600;
    `};
`;

const BreadcrumbsContainer = Container.extend`
  ${hideOnPrint};
  padding-top: 7.5px;
  padding-bottom: 20px;
  font-size: 12px;
  @media screen and (min-width: ${breakpoint.large}px) {
    padding-top: 12.5px;
  }
`;

Breadcrumbs.defaultProps = {
  sitemap: Map(),
  viewstate: Map(),
  disabled: false,
  currentItem: null
};

Breadcrumbs.propTypes = {
  sitemap: PropTypes.instanceOf(Map),
  viewstate: PropTypes.instanceOf(Map),
  location: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  currentItem: PropTypes.object
};

export default connect(Breadcrumbs, {}, store => ({
  sitemap: fromJS(window.sitemap),
  viewstate: store.viewstate
}));



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs.js